import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { CustomerInformationResponse } from '@features/succession/interfaces';
import { CustomerInformation, ListBoxItems } from '@features/succession/models';

import { ActionsTypes } from './actions';

export const CustomerInformationInitializing = createAction(
  ActionsTypes.CustomerInformationInitializing,
  props<{ customerInformation: CustomerInformation }>(),
);

export const CustomerInformationReload = createAction(ActionsTypes.CustomerInformationReload);

export const CustomerInformationResetWorkflow = createAction(
  ActionsTypes.CustomerInformationResetWorkflow,
);

export const CustomerInformationInitialized = createAction(
  ActionsTypes.CustomerInformationInitialized,
  props<{ customerInformation: CustomerInformation; selfCareListValues: ListBoxItems }>(),
);

export const CustomerInformationInitializingError = createAction(
  ActionsTypes.CustomerInformationInitializingError,
  props<{ error: HttpErrorResponse | CustomerInformationResponse['formErrorDTO'] }>(),
);

export const CustomerInformationSaveAndLoad = createAction(
  ActionsTypes.CustomerInformationSaveAndLoad,
  props<{ customerInformation: CustomerInformation }>(),
);

export const CustomerInformationPersist = createAction(
  ActionsTypes.CustomerInformationPersist,
  props<{ customerInformation: CustomerInformation; selfCareListValues: ListBoxItems }>(),
);

export const CustomerInformationSaveAndLoadComplete = createAction(
  ActionsTypes.CustomerInformationSaveAndLoadComplete,
  props<{ customerInformationResponse: CustomerInformationResponse }>(),
);

export const CustomerInformationSaveAndLoadError = createAction(
  ActionsTypes.CustomerInformationSaveAndLoadError,
  props<{ error: HttpErrorResponse | CustomerInformationResponse['formErrorDTO'] }>(),
);

export const CustomerInformationTokenClear = createAction(
  ActionsTypes.CustomerInformationTokenClear,
);

export const CustomerInformationConfirmation = createAction(
  ActionsTypes.CustomerInformationConfirmation,
);
